export default {
  heading: 'Get the Varo app',
  subTitle:
    'Download the app to easily set up your account, add your card to your digital wallet, and more.',
  description: 'Scan the QR code with your phone to get started.',
};
